/**
 * React component for fetching latest data with linear retry logic.
 * @param fetchFn the function which will return the data to be fetched
 * @param conditionFn the function which will return true if the fetched data is latest
 * @param onSuccess the function which will be called if the fetched data is latest
 * @param onFailure the function which will be called if the fetched data is not latest
 * @param maxRetries the maximum number of retries
 * @param interval the interval between retries in milliseconds
 * @param onStart the function which will be called when the fetch starts
 * @returns {Promise<void>} the promise which will be resolved when the fetch is complete
 */
export async function fetchLatestDataWithRetry({fetchFn,
                                                   conditionFn,
                                                   onSuccess,
                                                   onFailure,
                                                   maxRetries ,
                                                   interval,
                                                   onStart
                                               }) {
    let retryCount = 0;
    let latestResult;

    onStart();

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    while (retryCount < maxRetries) {
        latestResult = await fetchFn();

        if (await conditionFn(latestResult)) {
            await onSuccess(latestResult);
            return;
        }

        retryCount++;

        if (retryCount < maxRetries) {
            await delay(interval);
        }
    }

    await onFailure(latestResult);
}



// WEBPACK FOOTER //
// ./src/components/util/RetryLogic.js